<template>
  <div class="hm-form-radio-select">
    <FormGroup
      v-slot="{ hasError }"
      :label="label"
      :name="name"
      :helperText="helperText"
      :helperTextIconClass="helperTextIconClass"
    >
      <div>
        <fieldset>
          <div class="grid gap-4 ml-1">
            <div v-for="(item, key) in data" :key="key">
              <input
                :id="`${name}-${item.code}`"
                class="sr-only"
                type="radio"
                :name="name"
                :value="item.code"
                :checked="value === item.code"
                @input="(e) => $emit('input', e.target.value, item)"
              />
              <label
                :for="`${name}-${item.code}`"
                :class="{
                  'border-blue-500': value === item.code,
                  'border-grey-300': value !== item.code,
                }"
                class="flex items-center px-12 py-18 mx-6 my-8 rounded cursor-pointer border-2"
              >
                <div
                  class="flex items-center justify-center border-2 rounded-full h-20 w-20"
                  :class="{
                    'border-blue-500': value === item.code,
                    'border-grey-300': value !== item.code,
                  }"
                >
                  <div
                    v-if="value === item.code"
                    class="rounded-full h-10 w-10 bg-blue-500"
                  />
                </div>
                <h5 class="pl-12 text-sm font-semibold">
                  {{ item.label }}
                </h5>
              </label>
            </div>
          </div>
        </fieldset>
      </div>
    </FormGroup>
  </div>
</template>

<script>
import FormGroup from './FormGroup'
import bindAll from '@platform-shared/mixins/bindAll'

export default {
  components: { FormGroup },
  mixins: [bindAll],
  props: {
    data: { type: Array, required: true },
    textClass: { type: String, default: '' },
    label: { type: String, default: '' },
    name: { type: String, required: true },
    hasError: { type: Boolean },
    value: { type: String, default: '' },
    helperText: {
      type: String,
      default: '',
    },
    helperTextIconClass: {
      type: String,
      required: false,
      default: '',
    },
  },
}
</script>
